export default "__VITE_ASSET__CFm561zO__"